// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { Container, Content, Header, Body, Title, Button, Text, View, Icon, Footer, Left, Right, ListItem, List } from 'native-base';
import { StyleSheet, Animated, Platform } from 'react-native';
import Alert from '../../components/alert';
import FontAwesome from 'react-native-vector-icons/FontAwesome5';
//import Customers from "../../components/peopleList";
//import datas from "./data";
import { loadMonth, deleteTrans, updateDayTotals } from './actions';
import { Agenda, Calendar, CalendarList } from 'react-native-calendars'; //'../../components/calendar';
import { xdateToData } from '../../components/calendar/interface';
import styles from './styles';
import * as dateutils from '../../components/calendar/dateutils';
import XDate from 'xdate';
import ActionButton from 'react-native-action-button';
//import FooterButtons from '../../components/footerButtons';
import PopupMenu from '../../components/popupMenu';
import { truncateOnWord, poundMinus } from '../../components/globals';
import HamburgerMenu from '../../components/hamburgerMenu';
import DatePicker from '../../components/rn-datepicker';
import Modal from '../../components/modal';
import MonthPicker from './monthpicker';
import TransactionAdder from '../BankImport/transactionAdder';
import KeyHandler from '../../components/keyHandler';
const zeroPad = (num, places = 2) => String(num).padStart(places, '0');

export interface State {}
class DailyEntriesContainer extends React.Component {
	constructor(props) {
		super(props);

		//for month view:
		//console.log(XDate(props.lastTrans || null));
		this.selDay = xdateToData(new XDate());

		this.state = {
			marks: {},
			type: 'Month',
			bigCalMove: new Animated.Value(0),
			scrollY: new Animated.Value(0),
			selDay: this.selDay,
			hovering: null,
			showMonthSel: false,
			monthSel: {},
			selectedBankItem: null
		};
	}
	/*
  this.state.items needs to be agenda items
  loadItemsForMonth gets called when you select a DAY
  markedDates shows


  */
	componentDidMount() {
		this.selectDay(this.selDay);
		if (this.props.entries) {
			this.setMarksFromEntries(this.props.entries);
		}
	}
	componentWillReceiveProps(nextProps) {
		//console.log('SET entries', nextProps.entries);
		if (nextProps.entries) {
			this.setMarksFromEntries(nextProps.entries);
		}
	}

	setMarksFromEntries(entries) {
		const { marks } = this.state;

		for (var day in entries) {
			if (entries[day].length) {
				const exp = entries[day][0].dayTotals && entries[day][0].dayTotals.numExps > 0 ? { key: 'expense', color: 'red' } : null;
				const rec = entries[day][0].dayTotals && entries[day][0].dayTotals.numRecs > 0 ? { key: 'receipt', color: 'green' } : null;
				const trn = entries[day][0].dayTotals && entries[day][0].dayTotals.numTrans > 0 ? { key: 'transfer', color: 'blue' } : null;
				const bank = entries[day][0].dayTotals && entries[day][0].dayTotals.numBank > 0 ? { key: 'bank', color: '#a2a2a2' } : null;
				const dots = [rec, exp, trn, bank];
				marks[day] = { dots };
			}
		}

		if (Object.keys(marks).length > Object.keys(this.state.marks).length) {
			__DEV__ && console.log('SET MARKS', marks);
			this.setState({ marks: marks });
		}
	}

	toggleType() {
		//change calendar style
		const types = ['Week', 'Month'];
		const DURATION = 200;
		//idx=types.indexOf(this.state.type);
		//const newType = (idx==types.length-1)?types[0]:types[idx+1];
		const newType = this.state.type == 'Week' ? 'Month' : 'Week'; //faster

		Animated.timing(this.state.bigCalMove, {
			duration: DURATION,
			toValue: newType == 'Month' ? 0 : 1,
			useNativeDriver: true
		}).start();
		if (newType == 'Week') {
			setTimeout(() => {
				this.setState({ type: newType });
			}, DURATION - 80);
		} else {
			this.setState({ type: newType });
		}
	}

	render() {
		const expense = { key: 'expense', color: 'red', selectedColor: 'blue' };
		const taking = { key: 'taking', color: 'blue', selectedColor: 'blue' };
		const transfer = { key: 'transfer', color: 'green' };
		const dateSeld = this.state.selDay ? { [this.state.selDay.dateString]: { selected: true } } : undefined;
		const thisDayEntries = this.props.entries && this.selDay ? this.props.entries[this.selDay.dateString] : [];
		//console.log(this.state.selDay);

		const HEADER_HEIGHT = Platform.OS === 'ios' ? 60 : 73;

		const wholeMove = this.state.bigCalMove.interpolate({
			inputRange: [0, 1],
			outputRange: [0, -210],
			extrapolate: 'clamp'
		});
		const bigCalOpacity = this.state.bigCalMove.interpolate({
			inputRange: [0, 1],
			outputRange: [1, 0.3],
			extrapolate: 'clamp'
		});

		const bigCalScale = this.state.scrollY.interpolate({
			inputRange: [60, 150],
			outputRange: [1, 0.7],
			extrapolate: 'clamp'
		});
		const bigCalMove = this.state.scrollY.interpolate({
			inputRange: [60, 150],
			outputRange: [0, -50],
			extrapolate: 'clamp'
		});

		//console.log('state.marks', this.state.marks);
		//console.log('thisDayEntries', thisDayEntries);
		return (
			<Container style={styles.container}>
				<Header>
					<Left>
						<HamburgerMenu />
					</Left>
					<Body>
						<Title>Daily Entries</Title>
					</Body>
					<Right style={{ alignItems: 'center' }}>
						<Button style={{ flexDirection: 'column', marginBottom: 12 }} transparent onPress={() => this.props.navigation.navigate({ name: 'BankImport' })}>
							<Icon name="link" />
							<Text note style={{ color: 'white', alignSelf: 'center', margin: 0 }}>
								Bank
							</Text>
						</Button>
						{Platform.OS != 'web' && (
							<Button style={{ flexDirection: 'column', marginBottom: 12 }} transparent onPress={() => this.toggleType()}>
								<Icon name="calendar" style={{ fontSize: 22 }} />
								<Text note style={{ color: 'white', alignSelf: 'center', margin: 0 }}>
									{this.state.type}
								</Text>
							</Button>
						)}
					</Right>
				</Header>

				<Modal backdropPressToClose backButtonClose isOpen={this.state.showMonthSel} style={{ width: 'auto', height: 'auto' }}>
					{this.state.showMonthSel && (
						<MonthPicker
							value={this.state.selDay}
							onChange={(y, m) => {
								const dateString = `${y}-${zeroPad(m)}-${zeroPad(this.state.selDay.day)}`;
								const d = new XDate(dateString);
								this.setState({ showMonthSel: false });
								this.forceSelectDay(xdateToData(d));
							}}
							years={this.props.years}
						/>
					)}
				</Modal>

				{this.state.type == 'Week' ? (
					<Agenda
						items={this.props.entries}
						loadItemsForMonth={this.loadItems.bind(this)}
						//selected={'2017-12-16'}
						selected={this.state.selDay && this.state.selDay.dateString}
						onDayPress={day => {
							this.setState({ selDay: day });
						}}
						onDayChange={day => {
							this.setState({ selDay: day });
						}}
						renderItem={this.renderItem.bind(this)}
						renderEmptyDate={this.renderEmptyDate.bind(this)}
						rowHasChanged={this.rowHasChanged.bind(this)}
						renderDay={this.renderDay.bind(this)}
						displayLoadingIndicator
						pastScrollRange={11}
						futureScrollRange={12}
						markingType={'multi-dot'}
						markedDates={this.state.marks}
						firstDay={1}
					/>
				) : (
					<Animated.View style={{ flex: 1, transform: [{ translateY: wholeMove }] }}>
						<Animated.ScrollView
							scrollEventThrottle={20}
							style={{ opacity: bigCalOpacity, position: 'absolute', top: HEADER_HEIGHT + 180, width: '100%', height: '100%' }}
							onScroll={Animated.event([{ nativeEvent: { contentOffset: { y: this.state.scrollY } } }], { useNativeDriver: true })}>
							<List style={{ flex: 1, marginTop: 110, paddingBottom: HEADER_HEIGHT + 150 }}>
								{this.renderDayListHeader(this.selDay, thisDayEntries)}

								{thisDayEntries && thisDayEntries.length ? (
									thisDayEntries.map((item, i) => this.renderItem(item, null, i))
								) : (
									<Text note style={{ padding: 10 }}>
										No entries
									</Text>
								)}
								<View style={{ flex: 1, height: 100, paddingVertical: 50 }} />
							</List>
						</Animated.ScrollView>
						<Animated.View style={{ transform: [{ translateY: bigCalMove }, { scaleY: bigCalScale }] }}>
							{Platform.OS == 'web' ? (
								<Calendar
									style={{ paddingBottom: 0, borderBottomWidth: 0.5, borderBottomColor: '#DDD' }}
									ref={r => (this.cal = r)}
									current={this.selDay && this.selDay.dateString} //initially visible only
									onDayPress={day => {
										this.selectDay(day);
									}}
									markedDates={{ ...this.state.marks, ...dateSeld }}
									onMonthChange={month => {
										this.dotsForMonth(month);
									}}
									onVisibleMonthsChange={months => {
										__DEV__ && console.log('now these months are visible', months);
									}}
									markingType={'multi-dot'}
									renderHeader={date => (
										<Button transparent onPress={() => this.setState({ showMonthSel: true })}>
											<Text>{XDate(date).toString('MMMM yyyy')}</Text>
										</Button>
									)}
									firstDay={1}
									hideExtraDays={false}
									renderArrow={direction => <FontAwesome name={`chevron-${direction}`} style={{ color: '#438eb9' }} />}
								/>
							) : (
								<CalendarList
									style={{ paddingBottom: 0, borderBottomWidth: 0.5, borderBottomColor: '#DDD' }}
									ref={r => (this.cal = r)}
									current={this.selDay && this.selDay.dateString}
									horizontal
									pagingEnabled
									onDayPress={day => {
										console.log(day);
										this.selectDay(day);
									}}
									markedDates={{ ...this.state.marks, ...dateSeld }}
									onMonthChange={month => {
										this.dotsForMonth(month);
									}}
									onVisibleMonthsChange={months => {
										__DEV__ && console.log('now these months are visible', months);
									}}
									markingType={'multi-dot'}
									firstDay={1}
									hideExtraDays={false}
								/>
							)}
						</Animated.View>
					</Animated.View>
				)}
				<ActionButton buttonColor="#438eb9" offsetY={40} hideShadow style={{ opacity: 0.85 }}>
					<ActionButton.Item buttonColor="#1abc9c" title="Receipt" onPress={() => this._addReceipt()}>
						<FontAwesome name="sign-in-alt" style={styles.actionButtonIcon} />
					</ActionButton.Item>
					<ActionButton.Item buttonColor="#9b59b6" title="Expense" onPress={() => this._addExpense()}>
						<FontAwesome name="sign-out-alt" style={styles.actionButtonIcon} />
					</ActionButton.Item>
					<ActionButton.Item
						buttonColor="#1a6abc"
						title="Asset"
						onPress={() => {
							this._addAsset();
						}}>
						<FontAwesome name="toolbox" style={styles.actionButtonIcon} />
					</ActionButton.Item>
					<ActionButton.Item
						buttonColor="#3498db"
						title="Transfer"
						onPress={() => {
							this._addTransfer();
						}}>
						<FontAwesome name="exchange-alt" style={styles.actionButtonIcon} />
					</ActionButton.Item>
				</ActionButton>
				<KeyHandler plus={() => this._addReceipt()} minus={() => this._addExpense()} navigation={this.props.navigation} />
			</Container>
		);
	}

	// ------ For MONTH view -------
	selectDay(day) {
		__DEV__ && console.log(day, 'selected');
		this.selDay = day;
		this.setState({ selDay: day });
		this.props.loadMonth(day.dateString); //no if here - if you click the day, we reload its month!!
		// should be this.props.loadDay(day.dateString);
	}

	forceSelectDay(day) {
		this.selDay = day;
		if (this.cal) this.cal.updateMonth(new XDate(day.dateString));
		//this.props.loadMonth(day.dateString);
		this.setState({ selDay: day });
	}

	dotsForMonth(month) {
		if (!month) return;
		if (!this.props.entries[month.dateString]) {
			//if we have a selected date on another month
			if (this.selDay && month.month != this.selDay.month) this.selDay = null;
			this.props.loadMonth(month.dateString); //do this better - we only want the totals
			__DEV__ && console.log(`Load DOTS for ${month.dateString}`);
		} else {
			__DEV__ && console.log(`NOT LOAD DOTS for ${month.dateString}`, this.props.entries[month.dateString]);
		}
	}

	renderDayListHeader(day, entries) {
		//console.log('dayHeader', day.dateString, this.state.selDay.dateString);
		if (!day) return <Text>Please select a day</Text>; //|| day.dateString != this.state.selDay.dateString
		var date = new XDate(day.dateString);
		const today = day.dateString == XDate.today().dateString ? styles.today : undefined;
		const item = entries && entries[0];

		return (
			<ListItem itemDivider>
				<Body>
					<DatePicker
						date={date.toString('yyyy-MM-dd')}
						style={{ flex: 1 }}
						mode="date"
						placeholder=""
						format="YYYY-MM-DD"
						confirmBtnText="Confirm"
						cancelBtnText="Cancel"
						displayFormat="ddd DD/MM/YY"
						iconComponent={<FontAwesome name="calendar" />}
						customStyles={{
							dateInput: {
								paddingLeft: 5,
								borderColor: 'rgba(0, 0, 0, 0)'
								//alignItems: 'flex-end'
							}
						}}
						onDateChange={v => {
							v && this.forceSelectDay(xdateToData(XDate(v)));
							//onChange(v ? `${v.getFullYear()}-${zeroPad(v.getMonth() + 1, 2)}-${zeroPad(v.getDate(), 2)}` : null);
						}}
					/>
				</Body>
				{item && item.dayTotals ? (
					<Right>
						<Text style={[styles.dayTotalText, { marginTop: 5 }]}>{item ? '+ £' + Number(item.dayTotals.receivable).toFixed(2) : ''}</Text>
						<Text style={[styles.dayTotalText, { color: '#a47979' }]}>{item ? '- £' + Number(item.dayTotals.payable).toFixed(2) : ''}</Text>
					</Right>
				) : null}
			</ListItem>
		);
	}

	// ------ For Agenda/WEEK view: -------

	loadItems(day) {
		//console.log(day);
		if (!this.props.entries[day.dateString]) {
			this.props.loadMonth(day.dateString);
			__DEV__ && console.log(`Load Items for ${day.dateString}`);
		}
	}

	renderDay(date, item) {
		//current

		//this gets called for each item but only has date for first
		//console.log(date, item);
		const showTotalsFirst = item && item.dayTotals && Number(item.dayTotals.numExps) + Number(item.dayTotals.numRecs) == 1;
		if (date) {
			var date = new Date(date.timestamp);
			const today = dateutils.sameDate(date, XDate()) ? styles.today : undefined;

			return (
				<View style={[styles.day, { borderTopWidth: 0.5, borderColor: '#e3e6e8' }]}>
					<Text style={[styles.dayNum, today]}>{date.getDate()}</Text>
					<Text style={[styles.dayText, today]}>{XDate.locales[XDate.defaultLocale].dayNamesShort[date.getDay()]}</Text>
					{showTotalsFirst ? (
						<View>
							<Text style={[styles.dayTotalText, { marginTop: 5 }]}>{item ? '+ £' + Number(item.dayTotals.receivable).toFixed(2) : ''}</Text>
							<Text style={[styles.dayTotalText, { color: '#a47979' }]}>{item ? '- £' + Number(item.dayTotals.payable).toFixed(2) : ''}</Text>
						</View>
					) : null}
				</View>
			);
		} else {
			return (
				<View style={styles.day}>
					{!showTotalsFirst && item.dayTotals && item.order == 1 ? (
						<View>
							<Text style={[styles.dayTotalText, { marginTop: 5 }]}>{item ? '+ £' + Number(item.dayTotals.receivable).toFixed(2) : ''}</Text>
							<Text style={[styles.dayTotalText, { color: '#a47979' }]}>{item ? '- £' + Number(item.dayTotals.payable).toFixed(2) : ''}</Text>
						</View>
					) : null}
				</View>
			);
		}
	}

	renderItem(item, firstItemInDay, i) {
		//with vatreport, drop last digit to get expense or taking id (1=taking, 2=expense)
		var invoice = !!item.invoice_id;
		//summ==paid

		const trn = item.transaction_type == 'transfer';
		const bank = item.transaction_type == 'bank';
		const expense = item.transaction_type == 'expense';

		var baln = expense ? 0 - Number(item.payable) : Number(item.payable); //paid/received
		if (bank) baln = item.paid;
		var bal = poundMinus(baln, true);
		var colour = baln < 0 ? '#b30000' : '#006622';
		if (expense && item.paid > 0) colour = '#b30000';
		var iconcolour = invoice ? 'grey' : colour;
		var icon;
		if (invoice && item.invoice_status == 'void') colour = '#d9d9d9';
		if (invoice && item.invoice_status == 'sent') iconcolour = '#9b59b6';

		const voided = invoice && item.invoice_status == 'void';
		var recpay = expense ? 'Paid' : 'Received';
		if (trn) {
			icon = 'arrow-round-forward';
			colour = 'blue';
			iconcolour = 'blue';
			recpay = 'Transfer';
			bal = '';
		} else if (bank) {
			colour = item.paid > 0 ? '#4c5846' : '#8a5f77';
			iconcolour = '#d22484';
			icon = item.paid < 0 ? 'color-wand' : 'color-wand';
		} else if (!invoice) {
			icon = expense ? 'log-out' : 'log-in';
			if (item.series_freq) icon = 'refresh-circle';
		} else {
			icon = parseFloat(item.payable) >= 0 ? 'list-box' : 'undo';
		}

		//console.log(this.state.hovering)

		return (
			<React.Fragment key={i}>
				<ListItem
					icon
					style={[styles.item, { borderTopWidth: item.order != 0 ? 0.5 : 0, borderColor: '#e3e6e8', backgroundColor: this.state.selectedBankItem == item.id && '#b4d0e0' }]}
					onMouseEnter={() => this.setState({ hovering: item.id })}
					onMouseLeave={() => this.setState({ hovering: null })}
					onPress={() => {
						this.onSelectTrans(item);
					}}>
					<View style={{ flexDirection: 'row', alignSelf: 'stretch' }}>
						{bank ? (
							<View style={{ width: 20 }} />
						) : (
							<PopupMenu actions={voided ? [] : ['Edit', 'Copy', 'Delete']} style={{ color: 'grey', padding: 0, paddingHorizontal: 8 }} onPress={(e, i) => this._dropSelect(item, i)} />
						)}
						<Text numberOfLines={1} style={{ color: colour, marginLeft: 10, flex: 1 }}>
							{truncateOnWord(item.description, 40)}
						</Text>
						{!bank && this.state.hovering == item.id && !voided && (
							<>
								<Button small transparent onPress={() => this._dropSelect(item, 0)}>
									<Text>Edit</Text>
								</Button>
								<Button small transparent warning onPress={() => this._dropSelect(item, 1)}>
									<Text>Copy</Text>
								</Button>
								<Button small transparent danger onPress={() => this._dropSelect(item, 2)}>
									<Text>Delete</Text>
								</Button>
							</>
						)}
						<Text style={{ color: colour, textAlign: 'right', width: 100 }}>{bal}</Text>
					</View>

					<View style={{ flexDirection: 'row', alignSelf: 'stretch' }}>
						<Left style={{ width: 40 }}>
							<Icon name={icon} style={{ color: iconcolour }} />
							{!!bank && (
								<Text note style={{ fontSize: 12 }}>
									{item.category}
								</Text>
							)}
						</Left>

						<Body style={{ flex: 1 }}>
							<Text note style={{ textAlign: 'left' }}>
								{item.asset_id ? 'Asset Purchase' : item.name}
							</Text>
						</Body>
						{!!bank && <Text note>Tap to import</Text>}
						{item.receipt_ref && (
							<Right>
								<Icon name="attach" style={{ fontSize: 22, color: 'grey' }} />
							</Right>
						)}
						{!bank && (
							<Right>
								<Text note style={{ textAlign: 'right' }}>
									{recpay}:{'\n'}£{item.paid}
								</Text>
							</Right>
						)}
					</View>
				</ListItem>
				{this.state.selectedBankItem == item.id && (
					<TransactionAdder item={item} navigation={this.props.navigation} jwt={this.props.jwt} updateItem={() => this.props.loadMonth(item.date) && this.setState({ selectedBankItem: null })} />
				)}
			</React.Fragment>
		);
	}

	onSelectTrans(item) {
		if (item.transaction_type == 'bank') {
			return this.setState({ selectedBankItem: this.state.selectedBankItem == item.seTransaction_id ? null : item.seTransaction_id });
		}
		if (item.transaction_type == 'transfer' && item.account_id == 0) {
			return Alert.alert('Stock take entry', 'Edit this in settings', [{ text: 'Cancel' }, { text: 'OK', onPress: () => this.props.navigation.navigate('Settings') }]);
		}

		this.props.navigation.navigate(item.invoice_id ? 'Invoice' : 'Entry', {
			transId: item.id,
			id: item.id.slice(0, -1),
			assetId: item.asset_id
		});
	}

	_addReceipt() {
		//console.log(this.selDay.dateString);
		this.props.navigation.navigate('Entry', {
			addTrans: 'receipt',
			addDate: this.selDay && this.selDay.dateString
		});
	}

	_addExpense() {
		this.props.navigation.navigate('Entry', {
			addTrans: 'expense',
			addDate: this.selDay && this.selDay.dateString
		});
	}

	_addTransfer() {
		this.props.navigation.navigate('Entry', {
			addTrans: 'transfer',
			addDate: this.selDay && this.selDay.dateString
		});
	}

	_addAsset() {
		this.props.navigation.navigate('Entry', {
			addTrans: 'asset',
			addDate: this.selDay && this.selDay.dateString
		});
	}

	_duplicateThing(item) {
		__DEV__ && console.log(item);
		//const expenseDate = new Date().toISOString().split('T')[0];
		//const { description, account_id, net, payable, paid, vat, transaction_type, supplier_id, category } = item;
		//const cat = transaction_type == 'expense' ? { expenseCategory_id: category } : { takingCategory_id: category };
		this.props.navigation.navigate(item.invoice_id ? 'Invoice' : 'Entry', {
			addTrans: item.transaction_type,
			copyId: item.real_id
		});
	}

	_deleteItem(item, series = false) {
		__DEV__ && console.log('delete', item, series);
		this.props.deleteTrans(item, series);
	}

	_dropSelect(item, i) {
		if (i == 0) return this.onSelectTrans(item); //edit
		if (i == 1) return this._duplicateThing(item); //duplicate
		if (i == 2) {
			if (item.series_id)
				return Alert.alert(
					'Delete recurring ' + item.transaction_type,
					`Do you want to delete just this ${item.transaction_type} or all in the series?`,
					[
						{ text: 'Cancel', onPress: () => __DEV__ && console.log('Cancel Pressed'), style: 'cancel' },
						{ text: 'Just this', onPress: () => this._deleteItem(item) },
						{ text: `This and future ${item.transaction_type}s`, onPress: () => this._deleteItem(item, true) }
					],
					{ cancelable: true }
				);
			return Alert.alert(
				'Delete ' + item.transaction_type,
				`Permanently delete this ${item.transaction_type}?`,
				[
					{ text: 'Cancel', onPress: () => console.log('Cancel Pressed'), style: 'cancel' },
					{ text: 'OK', onPress: () => this._deleteItem(item) }
				],
				{ cancelable: true }
			);
		}
	}

	renderEmptyDate() {
		return <View style={styles.emptyDate} />;
	}

	rowHasChanged(r1, r2) {
		//console.log('has changed', r1, r2);
		return r1.paid !== r2.paid || r1.dayTotals !== r2.dayTotals || r1.payable !== r2.payable || r1.description != r2.description || r1.customer_id != r2.customer_id;
	}

	timeToString(time) {
		const date = new Date(time);
		return date.toISOString().split('T')[0];
	}
}

function bindAction(dispatch) {
	//https://stackoverflow.com/questions/34458261/how-to-get-simple-dispatch-from-this-props-using-connect-w-redux
	return {
		loadMonth: month => dispatch(loadMonth(month)),
		deleteTrans: (item, series) => dispatch(deleteTrans(item, series)),
		updateDayTotals: date => dispatch(updateDayTotals(date))
	};
}

const mapStateToProps = state => ({
	entries: state.dailyEntriesReducer.entries,
	years: state.globalReducer.yrs,
	lastTrans: state.globalReducer.busDetails && state.globalReducer.busDetails.lastTransaction,
	jwt: state.loginReducer.jwt && state.loginReducer.jwt.token
	//isLoading: state.customersReducer.isLoading
});
export default connect(mapStateToProps, bindAction)(DailyEntriesContainer);
